export class VehicleTransferScreenFiltersDataModel {
  selectedPickupLocation: String = '';
  selectedDropLocation: String = '';
  fromDateMilliSeconds: Number = 0;
  toDateMilliSeconds: Number = 0;
  selectedDispatchAddress: String = '';
  selectedBookingStatus: any = '';
  selectedSortType: String = '';
  opencloseFilter: boolean = false;
  selectedVehicleTypeId?: String = '';
  nextAvailableTime?: any;

  constructor(options?: {
    selectedPickupLocation: String;
    selectedDropLocation: String;
    fromDateMilliSeconds: Number;
    toDateMilliSeconds: any;
    selectedDispatchAddress: String;
    selectedBookingStatus: any;
    selectedSortType: String;
    opencloseFilter: boolean;
    selectedVehicleTypeId?: String;
    nextAvailableTime?: any;
  }) {
    if (options) {
      this.selectedPickupLocation = options.selectedPickupLocation;
      this.selectedDropLocation = options.selectedDropLocation;
      this.fromDateMilliSeconds = options.fromDateMilliSeconds;
      this.toDateMilliSeconds = options.toDateMilliSeconds;
      this.selectedDispatchAddress = options.selectedDispatchAddress;
      this.selectedBookingStatus = options.selectedBookingStatus;
      this.selectedSortType = options.selectedSortType;
      this.opencloseFilter = options.opencloseFilter;
      this.selectedVehicleTypeId = options.selectedVehicleTypeId;
      this.nextAvailableTime = options.nextAvailableTime
    }
  }
}
